import React, { FC } from 'react';

import { ModalGridItem } from 'components/molecules';
import { useLocale } from 'lib';
import { mdiBullhorn } from '@mdi/js';
import type { ContactOptionModalItemProps } from '..';

export const PushMessageOption: FC<ContactOptionModalItemProps> = () => {

  const { t } = useLocale();

  return (
    <ModalGridItem
      iconPath={mdiBullhorn}
      label={t('Alarm_Detail_Contact.Push_Message.Title')}
      subtitle={t('Alarm_Detail_Contact.Push_Message.Subtitle')}
      onClick={null}
    />
  );

};
